import { Card, Skeleton } from "@mantine/core";

export default function StatCardSkeleton({ className = "" }) {
  return (
    <Card className={`min-h-[100px] sm:min-h-[130px] p-3 sm:p-6 ${className}`}>
      <div className="flex flex-col min-h-[100px] sm:min-h-[130px] justify-center items-center w-full">
        <Skeleton height={20} width={80} radius="sm" className="mb-2" />
        <Skeleton height={24} width={140} radius="sm" />
      </div>
    </Card>
  );
}
